import { render, staticRenderFns } from "./OrganizationUploadDocumentPage.vue?vue&type=template&id=b5f9f73e&"
import script from "./OrganizationUploadDocumentPage.vue?vue&type=script&lang=js&"
export * from "./OrganizationUploadDocumentPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports